import { render, staticRenderFns } from "./agreementModal.vue?vue&type=template&id=1905a60b&scoped=true&"
import script from "./agreementModal.vue?vue&type=script&lang=ts&"
export * from "./agreementModal.vue?vue&type=script&lang=ts&"
import style0 from "./agreementModal.vue?vue&type=style&index=0&id=1905a60b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905a60b",
  null
  
)

export default component.exports